module.exports = __webpack_public_path__ + "static/media/img_follow_up.d7067a91.svg";